export default __webpack_public_path__ + "static/media/home.21fbbef5.svg";